import React from "react";
import { Building2, User } from "lucide-react";
import anniversarymessagebackground from "../../assets/celebrations/anniversarymessagebackground.png";

interface WorkAnniversaryMessageCardProps {
    name: string;
}

const WorkAnniversaryMessageCard: React.FC<WorkAnniversaryMessageCardProps> = ({ name }) => {
    return (
        <div className="w-full h-full">

            <div className="h-[35px]" />

            <div className="relative rounded-3xl overflow-hidden">

                <img
                    src={anniversarymessagebackground}
                    alt="Work Anniversary Background"
                    className="w-full h-[450px] object-cover rounded-3xl"
                />

                {/* AI Message */}
                <div
                    className="
                        absolute
                        left-1/2
                        bottom-[10%]
                        -translate-x-1/2
                        text-center
                        max-w-2xl
                        px-6
                    "
                >
                    <p className="text-white text-2xl font-medium leading-relaxed">
                        Thank you for your dedication,
                        hard work and contribution to our team!
                    </p>
                </div>

            </div>

            <div className="border-t border-white/10 mt-10 pt-10">
                <div className="grid grid-cols-2 gap-8">

                    <div className="flex items-center gap-4">
                        <div
                            className="
                                w-16 h-16
                                rounded-full
                                bg-gradient-to-br
                                from-yellow-500
                                to-yellow-700
                                flex
                                items-center
                                justify-center
                            "
                        >
                            <Building2 className="w-8 h-8 text-white" />
                        </div>

                        <div>
                            <p className="text-gray-400">
                                From
                            </p>

                            <p className="text-2xl font-bold text-white">
                                Realm Digital
                            </p>

                            <p className="text-gray-300">
                                Your PowerUp Family
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center gap-4">
                        <div
                            className="
                                w-16 h-16
                                rounded-full
                                bg-gradient-to-br
                                from-yellow-500
                                to-yellow-700
                                flex
                                items-center
                                justify-center
                            "
                        >
                            <User className="w-8 h-8 text-white" />
                        </div>

                        <div>
                            <p className="text-gray-400">
                                To
                            </p>

                            <p className="text-2xl font-bold text-white">
                                {name}
                            </p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
};

export default WorkAnniversaryMessageCard;